import { gql } from '@apollo/client';
/**
 * @const ContactListExternalQuery
 * @since 1.0.0
 */
export const ContactListExternalQuery = gql `
  query ContactListExternalQuery($input: ContactsInput) {
    contactsExternal(input: $input) {
      items {
        id
        name
        asset
      }
      count
    }
  }
`;
